export default __webpack_public_path__ + "static/media/BH Icons 30 p_Bedding.9c2a6428.svg";